export default {
  formatDate(date) {
    if (!date) { return null }

    const [year, month, day] = date.split('-')
    return `${day}.${month}.${year}`
  },
  parseDate(date) {
    if (!date) { return null }

    const [day, month, year] = date.substring(0,10).split('.')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  },
}